import { createSelector } from 'reselect';
import { groupRefundServicesByPassenger, groupServicesByType } from '../../../../../RefundSummary/utils';
import { OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
export const getGdsServicesRefundInfoState = (state) => state.refund.gdsServicesRefundInfo;
export const getGdsServicesRefundByType = createSelector(getGdsServicesRefundInfoState, services => {
    if (!!(services === null || services === void 0 ? void 0 : services.length)) {
        const servicesByType = groupServicesByType(services);
        const refundServicesByType = new Map();
        servicesByType.forEach((value, key) => {
            refundServicesByType.set(key, groupRefundServicesByPassenger(value));
        });
        return refundServicesByType;
    }
    return null;
});
export const getIsAnySeatsToRefund = createSelector(getGdsServicesRefundByType, gdsServicesRefundByType => !!(gdsServicesRefundByType === null || gdsServicesRefundByType === void 0 ? void 0 : gdsServicesRefundByType.get(OrderAdditionalServiceGdsServiceServiceType.Seat)));
